"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CircleLoader = _interopRequireDefault(require("../CircleLoader"));
var _RenderWhen = _interopRequireDefault(require("../../RenderWhen"));
var _Button = _interopRequireWildcard(require("../Button"));
var _angleDown = _interopRequireDefault(require("./angleDown.svg"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var noop = function noop() {};
var Collapsed = function Collapsed(_ref) {
  var _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    title = _ref.title,
    triggerBtnClassName = _ref.triggerBtnClassName,
    triggerBtnContentClassName = _ref.triggerBtnContentClassName,
    loading = _ref.loading,
    children = _ref.children,
    _ref$initialOpen = _ref.initialOpen,
    initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen,
    className = _ref.className,
    contentClassName = _ref.contentClassName,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? noop : _ref$onOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose;
  var _useState = (0, _react.useState)(initialOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var handleOpen = (0, _react.useCallback)(function () {
    setIsOpen(true);
    onOpen();
  }, [onOpen]);
  var handleClose = (0, _react.useCallback)(function () {
    setIsOpen(false);
    onClose();
  }, [onClose]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.root, className)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    activeColor: _Button.THEMES.PURPLE,
    activeTheme: _Button.THEMES.WHITE,
    className: (0, _classnames3.default)(_styles.default.button, _defineProperty({}, _styles.default['button--with-arrow'], arrow), triggerBtnClassName),
    contentClassName: (0, _classnames3.default)(_styles.default.buttonContent, triggerBtnContentClassName),
    icon: arrow ? _angleDown.default : undefined,
    iconClassName: arrow ? (0, _classnames3.default)(_styles.default['angle-icon'], _defineProperty({}, _styles.default['angle-icon--rotated'], isOpen)) : undefined,
    theme: _Button.THEMES.WHITE,
    width: _Button.WIDTHS.FLUID,
    onClick: isOpen ? handleClose : handleOpen
  }, title), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, null, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: loading
  }, /*#__PURE__*/_react.default.createElement(_CircleLoader.default, {
    className: _styles.default.loader
  })), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: isOpen
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.content, contentClassName)
  }, children))));
};
Collapsed.propTypes = {
  arrow: _propTypes.default.bool,
  title: _propTypes.default.node.isRequired,
  triggerBtnClassName: _propTypes.default.string,
  triggerBtnContentClassName: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  loading: _propTypes.default.bool,
  initialOpen: _propTypes.default.bool,
  className: _propTypes.default.string,
  contentClassName: _propTypes.default.string,
  onClose: _propTypes.default.func,
  onOpen: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(Collapsed);